import React from "react";
import { Star } from "lucide-react";

const TESTIMONIALS = [
  { name: "Anita Sharma", role: "Founder, Saanvi Studio",
    quote: "We replaced our entire content team. The AI nails our brand voice and the logos are stunning." },
  { name: "Marcus Chen", role: "Head of Growth, Northwind",
    quote: "90-day roadmap in 12 seconds. We executed it and tripled our pipeline." },
  { name: "Riya Patel", role: "Agency Owner, Pixel Forge",
    quote: "Onboarded 18 new clients with the white-label module. It feels like cheating." },
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
      <div className="grid md:grid-cols-3 gap-6">
        {TESTIMONIALS.map((t, i) => (
          <div
            key={t.name}
            data-reveal
            style={{ transitionDelay: `${i * 100}ms` }}
            className="glass rounded-2xl p-7 tilt-card"
          >
            <div className="flex gap-1 mb-4">
              {Array.from({ length: 5 }).map((_, j) => (
                <Star key={j} className="h-4 w-4 fill-indigo-400 text-indigo-400" />
              ))}
            </div>
            <p className="text-white/80 leading-relaxed">&ldquo;{t.quote}&rdquo;</p>
            <div className="mt-5">
              <div className="font-semibold">{t.name}</div>
              <div className="text-xs text-white/50">{t.role}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
